module.exports = {
      id: "icon-MenuToggle-usage",
      viewBox: "0 0 20 20",
      url: "/img/" + "063d56c0a9dcab4c3026b31719d540d0.svg#icon-MenuToggle",
      toString: function () {
        return this.url;
      }
    }